import { channelTypes } from '../channel';
import { messageTypeEnum, interactiveSubtypes } from './enums';

export const messagesConfig = Object.freeze({
	[messageTypeEnum.Text]: {
		canForward: true,
		extractForwardData: (message) => {
			return {
				content: message.content,
			};
		},
	},
	[messageTypeEnum.Image]: {
		canForward: true,
		canDownload: true,
		extractForwardData: (message) => {
			return {
				content: {
					...message.content,
				},
			};
		},
	},
	[messageTypeEnum.Location]: {
		canForward: true,
		extractForwardData: (message) => {
			return {
				content: {
					...message.content,
				},
			};
		},
	},
	[messageTypeEnum.Document]: {
		canForward: true,
		canDownload: true,
		extractForwardData: (message) => {
			return {
				content: {
					...message.content,
				},
			};
		},
	},
	[messageTypeEnum.Video]: {
		canForward: true,
		canDownload: true,
		extractForwardData: (message) => {
			return {
				content: {
					...message.content,
				},
			};
		},
	},
	[messageTypeEnum.Audio]: {
		canForward: true,
		canDownload: true,
		extractForwardData: (message) => {
			return {
				content: {
					...message.content,
				},
			};
		},
	},
	[messageTypeEnum.Order]: {
		canForward: false,
	},
	[messageTypeEnum.Template]: {
		canForward: false,
	},
	[messageTypeEnum.PaymentResponse]: {},
	[messageTypeEnum.ProductReplied]: {},
	[messageTypeEnum.Button]: {
		canForward: false,
	},

	[messageTypeEnum.Interactive]: {
		[interactiveSubtypes.Catalog]: {
			canForward: true,
		},
		[interactiveSubtypes.Product]: {
			canForward: true,
		},
		[interactiveSubtypes.Products]: {
			canForward: true,
		},
		[interactiveSubtypes.Flow]: {
			canForward: false,
		},
		[interactiveSubtypes.ButtonReply]: {
			canForward: false,
		},
		[interactiveSubtypes.nfmReply]: {
			canForward: false,
		},
		[interactiveSubtypes.InteractiveButtons]: {
			canForward: false,
		},
		[interactiveSubtypes.PaymentSummary]: {
			canForward: false,
		},
		extractForwardData: (message) => {
			return {
				content: {
					...message.content,
				},
				extra_data: {
					...message.extra_data,
				},
			};
		},
	},
	unsupported: {},
});

export const getMessageConfig = (message) => {
	if (message.type === messageTypeEnum.Interactive) {
		const interactiveType = message.content?.interactive?.type || message.content?.type;
		if (message.content?.type === interactiveSubtypes.ButtonReply) {
			return messagesConfig[messageTypeEnum.Interactive][interactiveSubtypes.ButtonReply];
		}
		if (!messagesConfig[messageTypeEnum.Interactive][interactiveType]) {
			return messagesConfig.unsupported;
		}
		return messagesConfig[messageTypeEnum.Interactive][interactiveType];
	}
	if (!messagesConfig[message.type]) return messagesConfig.unsupported;

	return messagesConfig[message.type];
};



export const channelTypeFilesValidations = {
	[channelTypes.WhatsApp]: {
		image: {
			maxSize: 5 * 1024 * 1024, // 5MB
		},
		video: {
			allowed: ['mp4', '3gpp'],
			maxSize: 16 * 1024 * 1024, // 16MB
		},
		audio: {
			allowed: ['ogg'], // maybe there are more formats
			maxSize: 16 * 1024 * 1024, // 16MB
		},
		document: {
			maxSize: 100 * 1024 * 1024, // 100MB
		},
	},
	[channelTypes.WhatsAppQR]: {
		image: {
			maxSize: 5 * 1024 * 1024, // 5MB
		},
		video: {
			allowed: ['mp4', '3gpp'],
			maxSize: 16 * 1024 * 1024, // 16MB
		},
		audio: {
			allowed: ['ogg'], // maybe there are more formats
			maxSize: 16 * 1024 * 1024, // 16MB
		},
		document: {
			maxSize: 100 * 1024 * 1024, // 100MB
		},
	},
	[channelTypes.Instagram]: {
		image: {
			maxSize: 8 * 1024 * 1024, // 8MB
		},
		video: {
			allowed: ['mp4', '3gpp', 'ogg', 'avi', 'mov', 'webm'],
			maxSize: 25 * 1024 * 1024, // 25MB
		},
		audio: {
			allowed: ['aac', 'm4a', 'wav', 'mp4'],
			maxSize: 25 * 1024 * 1024, // 25MB
		},
		document: {
			maxSize: 25 * 1024 * 1024, // 25MB
		},
	},
	[channelTypes.Messenger]: {
		image: {
			maxSize: 8 * 1024 * 1024, // 8MB
		},
		video: {
			allowed: ['mp4', '3gpp', 'ogg', 'avi', 'mov', 'webm'],
			maxSize: 25 * 1024 * 1024, // 25MB
		},
		audio: {
			allowed: ['aac', 'm4a', 'wav', 'mp4'],
			maxSize: 25 * 1024 * 1024, // 25MB
		},
		document: {
			maxSize: 25 * 1024 * 1024, // 25MB
		},
	},
};
